import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, MailIcon } from 'lucide-react';
import type { Consultant } from '../../types/content';
import { buttonClasses } from '../../utils/buttonStyles';
import { ConsultantAvatar } from './ConsultantAvatar';
interface ConsultantCardProps {
  consultant: Consultant;
  headingLevel?: 'h2' | 'h3';
}
export function ConsultantCard({
  consultant,
  headingLevel = 'h3'
}: ConsultantCardProps) {
  const Heading = headingLevel;
  return <article className="flex h-full flex-col overflow-hidden rounded-2xl border border-plum/10 bg-white" data-id="element-58" data-mp="1ius64glaetll">
      <ConsultantAvatar consultant={consultant} data-id="element-59" data-mp="1e3tn398wzhen" />
      <div className="flex flex-1 flex-col p-6" data-id="element-60" data-mp="1e2ik3bnamdol">
        <Heading className="text-xl font-semibold text-aubergine" data-id="element-61" data-mp="196aa0cnydaoa">
          <Link to={`/consultants/${consultant.slug}`} className="transition-colors duration-150 hover:text-copper-deep" data-id="element-62" data-mp="26kw7ehb06h9f">
            {consultant.name}
          </Link>
        </Heading>
        <p className="mt-1 text-sm text-plum/65" data-id="element-63" data-mp="21s36y5mkhv35">{consultant.title}</p>
        <div className="mt-auto flex flex-wrap items-center gap-x-5 gap-y-3 pt-6" data-id="element-64" data-mp="3h1gqyozchwef">
          <a href={`mailto:${consultant.email}`} className={buttonClasses('dark', 'sm')} data-id="element-65" data-mp="3lz04fmo7y55b">
            <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-66" data-mp="37bx3t74lngdr" />
            Email {consultant.firstName}
          </a>
          <Link to={`/consultants/${consultant.slug}`} className="inline-flex items-center gap-1.5 text-sm font-semibold text-plum transition-colors duration-150 hover:text-copper-deep" data-id="element-67" data-mp="3c8xb1ld6qp6g">
            Profile
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-68" data-mp="2oc9gqsqj3idc" />
          </Link>
        </div>
      </div>
    </article>;
}